import { ProjectIcon } from '@cfs-fixings/shared'
import { ProjectResource } from '@/api/serverApi'
import { Link } from 'react-router-dom'

type PropTypes = {
  projects?: ProjectResource[]
  footerElements?: React.ReactNode[]
  dropdown: ({ project }: {project: ProjectResource}) => JSX.Element
}

function ProjectGridView ({ projects, footerElements, dropdown: DropDown }: PropTypes) {
  return (
    <ul className="w-full flex flex-row flex-wrap gap-5">
      {
        projects?.map((project) => (
          <Link
            key={project.id}
            className="bg-gray-50 hover:bg-gray-75 transition-all border border-gray-400 rounded-md px-[15px] py-[18px] w-[245px]"
            to={`/projects/${project.id}`}
          >
            <li>
              <div className="flex flex-col items-start">
                <div className="flex justify-between w-full items-center">
                  <ProjectIcon className="h-[18px] w-[18px] min-h-[18px] min-w-[18px] mb-2.5" />
                  <DropDown project={project} />
                </div>
                <p className="text-sm font-medium leading-[16.8px] mb-[3px]">{project.name}</p>
                <p className="text-xs font-medium leading-[16.8px] text-gray-600">{`${project.designs_count} Design Files`}</p>
              </div>
            </li>
          </Link>
        ))
      }
      {
        ...(footerElements ?? [])
      }
    </ul>
  )
}

export default ProjectGridView
